import React, { createContext, useContext, useState } from 'react';
import type { CallHistoryItem } from '../features/dialer/DialerHistory';

interface DialerCallDetailContextValue {
  dialerCallDetail: CallHistoryItem | null;
  setDialerCallDetail: React.Dispatch<React.SetStateAction<CallHistoryItem | null>>;
}

const DialerCallDetailContext = createContext<DialerCallDetailContextValue>({
  dialerCallDetail: null,
  setDialerCallDetail: () => {},
});

export const DialerCallDetailProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [dialerCallDetail, setDialerCallDetail] = useState<CallHistoryItem | null>(null);
  return (
    <DialerCallDetailContext.Provider value={{ dialerCallDetail, setDialerCallDetail }}>
      {children}
    </DialerCallDetailContext.Provider>
  );
};

export const useDialerCallDetail = () => useContext(DialerCallDetailContext);
